import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import VoucherTable from "../../../Components/Table/VoucherTable";
import { Link } from "react-router-dom";
import CustomButton from "../../../Components/Button/CustomButton";
import { GetVoucher } from "../../../APIs/Function/Voucher/GetVoucher";

const Voucher = () => {
  const [voucherData, setVoucherData] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleVoucher = async () => {
    try {
      setLoading(true);
      let res = await GetVoucher();
      console.log(res.r);
      setVoucherData(res.r);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleVoucher();
  }, []);
  return (
    <Box sx={{ height: "100vh", mt: "10px", p: 2, boxSizing: "border-box" }}>
      <VoucherTable
        setVoucherData={setVoucherData}
        voucherData={voucherData}
        loadinga={loading}
      />
      <Box
        sx={{
          display: "flex",
          mt: "25px",
          justifyContent: "end",
          width: "100%",
        }}
      >
        <Link to={"/addvoucher"}>
          <CustomButton
            sx={{
              width: "100%",
              bgcolor: "#31AEF4",
              "&:hover": {
                bgcolor: "#31AEF4",
              },
            }}
          >
            ADD +
          </CustomButton>
        </Link>
      </Box>
    </Box>
  );
};

export default Voucher;
